<template>
  <div>
    <template v-if="booklist.length <= 0">
      <div class="datanull">
        <img src="~img/personal/notwrite.png" alt="" />
        <p>您还没有写过书，快来发布第一本大作吧！</p>
        <a class="btn" href="javaScript:" @click="goBookSet(0, false)"
          >创建作品</a
        >
      </div>
    </template>
    <template v-else>
      <div class="block">
        <ul class="collectlist mywrite clearfix">
          <li v-for="book in booklist" :key="book.id" :class="{ small: small }">
            <a
              href="javaScript:"
              @click="goBookSet(book.id, book.allowPrice, book.iname)"
            >
              <img
                v-lazy="
                  isSign
                    ? imgURL + '/' + book.iconUrlMedium
                    : imgURL + '/' + book.iiconUrlMedium
                "
                :src="
                  isSign
                    ? imgURL + '/' + book.iconUrlMedium
                    : imgURL + '/' + book.iiconUrlMedium
                "
                alt=""
              />
              <template v-if="isDel">
                <a
                  class="delebook"
                  href="javaScript:"
                  @click.stop="delectbook(book.id)"
                >
                  <img src="~img/delete.png" alt="" />
                </a>
              </template>

              <p class="bookname">
                <span class="fl ellipsis">{{
                  isSign ? book.name : book.iname
                }}</span>
                <img
                  v-if="book.signStatusCode >= 0"
                  class="fl"
                  src="~img/sign.png"
                  alt="签约"
                />
              </p>
            </a>
            <p class="chapters">
              <span>已更新{{ book.chapterCount }}章节</span>
              <span>{{ book.words }}字</span>
            </p>
            <div class="buttons" v-if="!isSign">
              <a
                href="javaScript:"
                @click="goBookSet(book.id, book.allowPrice, book.iname)"
                >新建章节</a
              >
              |
              <a
                href="javaScript:"
                @click="gonewchapter(book.id, book.allowPrice, book.iname)"
                >已发布章节</a
              >
              <!-- <a
                :class="{ isopen: true, error: book.inspectStatus == -2 }"
                href="javaScript:"
                v-if="!book.open && book.inspectStatus == 0"
              ></a>
              <a
                :class="{ isopen: true, error: book.inspectStatus == -2 }"
                href="javaScript:"
                v-else
                >{{ book.inspectDesc }}</a
              > -->
             <!--  <a
                @click="gopubBook(book.id, book.inspectStatus)"
                class="signbtn"
                v-if="
                  !book.open &&
                    book.words > 5000 &&
                    (book.inspectStatus == 0 || book.inspectStatus == 3)
                "
                href="javaScript:"
                >申请发布</a
              > -->
            </div>
            <!-- <div class="signelse" v-else>
              <a
                class="signStatus"
                href="javaScript:"
                :title="book.signStatusDesc"
              >
                {{ book.signStatusDesc !== null ? book.signStatusDesc : "" }}
              </a>
              <a
                v-if="book.signStatusCode !== 10024"
                @click="goSign(book.id, book.allowPrice, book.name)"
                class="signbtn"
                href="javaScript:"
                >{{
                  book.signStatusCode == -3 ||
                  book.signStatusCode == -4 ||
                  book.signStatusCode == -2 ||
                  book.signStatusCode == -1
                    ? "申请签约"
                    : book.signStatusCode == 0 ||
                      book.signStatusCode == 1 ||
                      book.signStatusCode == 2
                    ? "查看"
                    : "查看信息"
                }}</a
              >
              <a
                v-if="book.signStatusCode == 10024"
                @click="gonewchapter(book.id, book.allowPrice, book.name)"
                class="signbtn"
                href="javaScript:"
                >添加章节</a
              >
            </div> -->
            <div class="bookStatus">
                <img v-if="!book.open" src="~img/author/tag_cg@2x.svg" alt="">
                <img v-if="book.open" src="~img/author/tag_gk@2x.svg" alt="">
            </div>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import { publishBook } from "apiurl/author";
export default {
  props: {
    booklist: Array,
    isSign: Boolean,
    small: Boolean,
    isDel: Boolean
  },
  created() {},
  methods: {
    goBookSet(bookid, allowPrice, name) {
      this.$store.dispatch("setAInfo", { bookid, allowPrice, name });
      this.$router.push("/authorManage/newChapter/" + bookid);
    },
    gonewchapter(bookid, allowPrice, name) {
      /*  setAbookid(bookid);
                                                       settoll(allowPrice); */
      this.$store.dispatch("setAInfo", { bookid, allowPrice, name });
      this.$router.push("/authorManage/published/" + bookid);
    },
    goSign(bookid, allowPrice, name) {
      this.$store.dispatch("setAInfo", { bookid, allowPrice, name });
      this.$router.push("/authorManage/sign/" + bookid);
    },
    // 作品发布
    gopubBook(id, status) {
      if (status == 0 || status == 3) {
        publishBook(id)
          .then(res => {
            if (res.success) {
              this.$emit("openbook", true);
            }
          })
          .catch(() => {});
      }
    },
    // 删除作品
    delectbook(id) {
      this.$emit("getbookid", id);
    }
  }
};
</script>

<style lang="stylus" scoped>
.collectlist
    display block
    padding-bottom 40px
    &.mywrite
        padding-bottom 40px
        li
            width 160px
            height:320px;
            background:rgba(255,255,255,1);
            box-shadow:0px 1px 3px 0px rgba(0,0,0,0.1);
            border-radius:3px;
            margin-right 36px
            position relative
            margin-bottom 19px
            &:nth-child(5n)
                margin-right 0px
            &.small
                margin-right 36px
                &:nth-child(4n)
                    margin-right 0px
            a
                &:hover
                    .delebook
                        opacity 1
            img
                width 160px
                height 220px
                border-radius:3px 3px 0px 0px;
            .delebook
                position absolute
                width 28px
                height 18px
                top 191px
                right 0px
                color #fff
                transition all 0.3s ease-in-out
                opacity 0
                img
                    width 28px
                    height 28px
            .bookStatus
                position absolute
                top -3px
                right 16px
                img
                    width 31px
                    height 32px

    li
        display inline-block
        float left
        width 80px
        a
            width 100%
            display block
            img
                width 100%
                height 112px
                margin-bottom 10px
            p
                font-size 14px
                font-weight 600
                color rgba(51, 51, 51, 1)
                height 16px
                line-height 16px
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
                margin-left 16px
            .bookname
                span
                    max-width 80%
                img
                    width 17px
                    height 17px
        .chapters
            padding 10px 0
            font-size 12px
            margin-left 16px
            color #999
            span
                display inline-block
                &:nth-child(1)
                    margin-right 2px
        .buttons
            color #666
            margin-left 16px
            a
                text-decoration none
                color #666
                display inline-block
                width auto
                font-size 12px
                &.isopen
                    margin-top 10px
                    color #48a2df
                &.error
                    color #F85151
                &:hover
                    color #48A2DF !important
            .signbtn
                width 72px
                height 26px
                background #48a2df
                border-radius 4px
                font-size 12px
                color rgba(255, 255, 255, 1)
                text-align center
                display block
                line-height 26px
                margin 10px auto
                &:hover
                    color rgba(255, 255, 255, 1) !important
        .signelse
            text-align center
            .signbtn
                width 72px
                height 26px
                background #48a2df
                border-radius 4px
                font-size 12px
                color rgba(255, 255, 255, 1)
                text-align center
                display block
                line-height 26px
                margin 0 auto
            .isopen
                font-size 14px
                color rgba(136, 136, 136, 1)
                line-height 20px
                height 20px
                margin-bottom 8px
                color #2A94EF
            .signStatus
                font-size 14px
                color rgba(136, 136, 136, 1)
                line-height 20px
                height 20px
                margin-bottom 8px
                overflow hidden
                text-overflow ellipsis // 文本溢出显示省略号
                white-space nowrap // 文本不会换行（单行文本溢出）
                color #48a2df
</style>
